import { api } from '@config/api';
import { type AxiosRequestConfig, isAxiosError } from 'axios';
import type { FiltrosPainel } from '../types/Painel';
import { paramsDosFiltros, paramsSerializer } from './painelService';

/** Nome do `Content-Disposition`: `filename*` (UTF-8) tem prioridade sobre `filename`. */
function nomeDoArquivo(header: string | undefined): string {
  const utf8 = header?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (utf8) {
    try {
      return decodeURIComponent(utf8);
    } catch {
      // cai no `filename` simples
    }
  }
  return header?.match(/filename="?([^";]+)"?/i)?.[1] ?? 'exportacao.xlsx';
}

/** Baixa um .xlsx de `url` e dispara o download no navegador. */
async function baixarArquivo(url: string, config: AxiosRequestConfig): Promise<void> {
  let res: Awaited<ReturnType<typeof api.get<Blob>>>;
  try {
    res = await api.get<Blob>(url, { ...config, responseType: 'blob' });
  } catch (error) {
    // Com `responseType: 'blob'` o corpo do erro também é Blob: vira JSON para `mensagemDeErro`.
    if (isAxiosError(error) && error.response?.data instanceof Blob) {
      try {
        error.response.data = JSON.parse(await error.response.data.text());
      } catch {
        error.response.data = undefined;
      }
    }
    throw error;
  }
  const href = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = href;
  a.download = nomeDoArquivo(res.headers['content-disposition']);
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}

export const exportacaoService = {
  /** Destinatários do brinde (spec 08). */
  baixar: (id: string, usoInterno: boolean) =>
    baixarArquivo(`/campanhas/${id}/exportacao`, { params: { usoInterno } }),
  /** Lista de participantes com os filtros e a ordem da tela, sem paginação (spec 15 R1). */
  baixarParticipantes: (id: string, f: FiltrosPainel) => {
    const { pagina: _p, porPagina: _pp, ...filtros } = f;
    return baixarArquivo(`/campanhas/${id}/exportacao/participantes`, {
      params: paramsDosFiltros(filtros),
      paramsSerializer,
    });
  },
};
